module.exports = __webpack_public_path__ + "static/residential-4-8f17ca9c2238b7323c04a1a9ea5e058a.jpg";